"use client";

import { useCallback } from "react";
import { useAtomValue } from "jotai";
import { ATOM_auth } from "@lattice/frontend/lib/jotai/auth.atom";
import { E_Page } from "@lattice/frontend/lib/routes/routes";
import { buildAuthUrl } from "@lattice/frontend/lib/auth/build-auth-url";

type T_LandingCta = {
  isAuthed: boolean;
  goToSignUp: () => void;
  goToLogin: () => void;
};

export const useLandingCta = (): T_LandingCta => {
  const isAuthed = useAtomValue(ATOM_auth);

  const goToLogin = useCallback(() => {
    window.location.href = buildAuthUrl();
  }, []);

  const goToSignUp = useCallback(() => {
    if (isAuthed) {
      window.location.href = E_Page.Shell;
      return;
    }
    window.location.href = buildAuthUrl({ redirect: "app/prism/new" });
  }, [isAuthed]);

  return { isAuthed, goToSignUp, goToLogin };
};
